import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Skeleton } from '../components/ui/skeleton';
import { ArrowRight, Star } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Trainers() {
  const [trainers, setTrainers] = useState([]);
  const [loading, setLoading] = useState(true);
    const fetchTrainers = async () => {
    try {
      const response = await axios.get(`${API}/trainers`);
      setTrainers(response.data);
    } catch (error) {
      console.error('Error fetching trainers:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrainers();
  }, []);



  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="mb-12">
            <p className="font-heading uppercase tracking-widest text-muted-foreground text-sm mb-2">
              Notre équipe
            </p>
            <h1 className="font-heading font-black text-4xl sm:text-5xl mb-4">
              Nos Coachs
            </h1>
            <p className="text-muted-foreground max-w-2xl">
              Découvrez nos coachs professionnels et choisissez celui qui correspond 
              à vos objectifs d'entraînement.
            </p>
          </div>

          {/* Trainers Grid */}
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1, 2, 3].map((i) => (
                <Card key={i} className="overflow-hidden">
                  <Skeleton className="aspect-[4/3] w-full" />
                  <CardContent className="p-6">
                    <Skeleton className="h-6 w-32 mb-2" />
                    <Skeleton className="h-4 w-24 mb-4" />
                    <Skeleton className="h-10 w-full" />
                  </CardContent>
                </Card>
              ))}
            </div>
          ) : trainers.length === 0 ? (
            <div className="text-center py-16">
              <p className="text-muted-foreground text-lg">
                Aucun coach disponible pour le moment.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="trainers-grid">
              {trainers.map((trainer) => (
                <Card 
                  key={trainer.id} 
                  className="group overflow-hidden border-2 hover:border-[#D4FF00]/30 transition-colors"
                  data-testid={`trainer-card-${trainer.id}`}
                >
                  <div className="aspect-[4/3] overflow-hidden relative">
                    <img 
                      src={trainer.photo_url} 
                      alt={trainer.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      onError={(e) => {
                        e.target.src = 'https://images.pexels.com/photos/1618042/pexels-photo-1618042.jpeg';
                      }}
                    />
                    <div className="absolute top-4 right-4">
                      <Badge className="bg-[#D4FF00] text-black font-bold">
                        1 crédit/séance
                      </Badge>
                    </div>
                  </div>
                  <CardContent className="p-6">
                    <div className="flex items-start justify-between mb-2">
                      <div>
                        <h3 className="font-heading font-bold text-xl">{trainer.name}</h3>
                        <p className="text-muted-foreground text-sm">{trainer.specialty}</p>
                      </div>
                      <div className="flex items-center gap-1 text-[#D4FF00]">
                        <Star className="w-4 h-4 fill-current" />
                        <span className="text-sm font-medium">4.9</span>
                      </div>
                    </div>
                    <Link to={`/book/${trainer.id}`}>
                      <Button 
                        className="w-full mt-4 bg-primary text-primary-foreground hover:bg-primary/90 font-bold uppercase tracking-wide"
                        data-testid={`book-trainer-${trainer.id}`}
                      >
                        Réserver
                        <ArrowRight className="ml-2 w-4 h-4" />
                      </Button>
                    </Link>
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
